module.exports = __webpack_public_path__ + "80597334da867266edace7b5208e0751.png";